import { Colors } from "@/enums/Colors";
import { AppBar, BaseAppBarProps } from "@/external/ensolvers-core-frontend-mui-v5/components/Main/AppBar";
import { AppBarBody } from "./AppBarBody";

type DefaultAppBarProps = BaseAppBarProps & {
  breadcrumbs: string;
};

function DefaultAppBar({ open, clippedDrawer, drawerWidth, onClickMenuButton, onClickMobileMenuButton, breadcrumbs }: DefaultAppBarProps) {
  return (
    <>
      <AppBar
        open={open}
        clippedDrawer={clippedDrawer}
        drawerWidth={drawerWidth}
        onClickMenuButton={onClickMenuButton}
        onClickMobileMenuButton={onClickMobileMenuButton}
        AppBarProps={{
          sx: {
            position: "absolute",
            backgroundColor: Colors.LIGHT_GRAY_BG_F6F8FA,
            color: Colors.BLACK,
            borderRadius: "1rem 1rem 0 0",
            borderColor: Colors.LIGHT_GRAY,
            paddingTop: "0.4rem",
            paddingRight: "0.4rem",
            "& .MuiToolbar-root": {
              minHeight: "44px",
            },
          },
        }}
      >
        <AppBarBody breadcumbs={breadcrumbs} />
      </AppBar>
    </>
  );
}

export default DefaultAppBar;
